import { render, staticRenderFns } from "./checkField.vue?vue&type=template&id=10608a92&"
import script from "./checkField.vue?vue&type=script&lang=js&"
export * from "./checkField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "checkField.vue"
export default component.exports